"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _SidenavContext = require("../layout/SidenavContext");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _BackgroundColorContext = require("../BackgroundColorContext");

var _Flex = _interopRequireDefault(require("../flex/Flex"));

var _Bleed = _interopRequireDefault(require("../bleed/Bleed"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

var _excluded = ["href", "children", "newWindow", "selected", "icon", "tabIndex", "onClick"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var collapsedIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));

var collapsableIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}));

var externalLinkIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}));

var DxcSidenav = function DxcSidenav(_ref) {
  var children = _ref.children,
      title = _ref.title;
  var colorsTheme = (0, _useTheme["default"])();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.sidenav
  }, /*#__PURE__*/_react["default"].createElement(SidenavContainer, null, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.sidenav.backgroundColor
  }, title, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "column",
    gap: "1rem"
  }, _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, child, index !== _react["default"].Children.count(children) - 1 && /*#__PURE__*/_react["default"].createElement(Divider, null));
  })))));
};

var Title = function Title(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(_Bleed["default"], {
    horizontal: "1rem"
  }, /*#__PURE__*/_react["default"].createElement(SidenavTitle, null, children));
};

var Section = function Section(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(_Bleed["default"], {
    horizontal: "1rem"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "column"
  }, children));
};

var Group = function Group(_ref4) {
  var children = _ref4.children,
      title = _ref4.title,
      _ref4$collapsable = _ref4.collapsable,
      collapsable = _ref4$collapsable === void 0 ? false : _ref4$collapsable,
      icon = _ref4.icon;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var selectedGroup = (0, _react.useMemo)(function () {
    return collapsed ? _react["default"].Children.toArray(children).some(function (child) {
      var _child$props;

      return (_child$props = child["props"]) === null || _child$props === void 0 ? void 0 : _child$props.selected;
    }) : false;
  }, [collapsed, children]);
  return /*#__PURE__*/_react["default"].createElement(SidenavGroup, null, collapsable && title ? /*#__PURE__*/_react["default"].createElement(SidenavGroupTitleButton, {
    role: "button",
    "aria-expanded": !collapsed,
    onClick: function onClick() {
      return setCollapsed(!collapsed);
    },
    selectedGroup: selectedGroup
  }, /*#__PURE__*/_react["default"].createElement(SidenavContent, null, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(SidenavIcon, {
    src: icon
  }) : icon, title), collapsed ? collapsedIcon : collapsableIcon) : title && /*#__PURE__*/_react["default"].createElement(SidenavGroupTitle, null, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(SidenavIcon, {
    src: icon
  }) : icon, title), !collapsed && children);
};

var Link = /*#__PURE__*/(0, _react.forwardRef)(function (_ref5, ref) {
  var href = _ref5.href,
      children = _ref5.children,
      _ref5$newWindow = _ref5.newWindow,
      newWindow = _ref5$newWindow === void 0 ? false : _ref5$newWindow,
      _ref5$selected = _ref5.selected,
      selected = _ref5$selected === void 0 ? false : _ref5$selected,
      icon = _ref5.icon,
      _ref5$tabIndex = _ref5.tabIndex,
      tabIndex = _ref5$tabIndex === void 0 ? 0 : _ref5$tabIndex,
      onClick = _ref5.onClick,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref5, _excluded);
  var setIsSidenavVisibleResponsive = (0, _SidenavContext.useResponsiveSidenavVisibility)();

  var handleClick = function handleClick($event) {
    onClick === null || onClick === void 0 ? void 0 : onClick($event);
    setIsSidenavVisibleResponsive === null || setIsSidenavVisibleResponsive === void 0 ? void 0 : setIsSidenavVisibleResponsive(false);
  };

  return /*#__PURE__*/_react["default"].createElement(SidenavLink, (0, _extends2["default"])({
    selected: selected,
    href: href ? href : undefined,
    target: href ? newWindow ? "_blank" : "_self" : undefined,
    ref: ref,
    tabIndex: tabIndex,
    onClick: handleClick
  }, otherProps), /*#__PURE__*/_react["default"].createElement(SidenavContent, null, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(SidenavIcon, {
    src: icon
  }) : icon, children), newWindow && externalLinkIcon);
});

var SidenavContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  box-sizing: border-box;\n  width: 280px;\n  @media (max-width: ", "rem) {\n    width: 100vw;\n  }\n\n  height: 100%;\n  padding: 2rem 1rem;\n\n  overflow-y: auto;\n  overflow-x: hidden;\n  ::-webkit-scrollbar {\n    width: 2px;\n  }\n  ::-webkit-scrollbar-track {\n    background-color: ", ";\n    border-radius: 3px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: 3px;\n  }\n"])), function (props) {
  return props.theme.backgroundColor;
}, _variables.responsiveSizes.medium, function (props) {
  return props.theme.scrollBarTrackColor;
}, function (props) {
  return props.theme.scrollBarThumbColor;
});

var SidenavTitle = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 27px;\n  display: flex;\n  align-items: center;\n  color: ", ";\n  text-transform: ", ";\n  letter-spacing: ", ";\n  padding: 0.5rem 1.2rem;\n\n  svg {\n    margin-right: 0.5rem;\n  }\n"])), function (props) {
  return props.theme.titleFontFamily;
}, function (props) {
  return props.theme.titleFontStyle;
}, function (props) {
  return props.theme.titleFontWeight;
}, function (props) {
  return props.theme.titleFontSize;
}, function (props) {
  return props.theme.titleFontColor;
}, function (props) {
  return props.theme.titleFontTextTransform;
}, function (props) {
  return props.theme.titleFontLetterSpacing;
});

var Divider = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 1px;\n  background-color: #999999;\n"])));

var SidenavGroup = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  a {\n    padding: 0.5rem 1.2rem 0.5rem 2.25rem;\n  }\n"])));

var SidenavGroupTitle = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  svg {\n    width: 16px;\n    margin-right: 0.5rem;\n  }\n  box-sizing: border-box;\n  width: 100%;\n\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 18px;\n\n  display: flex;\n  align-items: center;\n  margin: 0px;\n  padding: 0.5rem 1.2rem;\n"])), function (props) {
  return props.theme.groupTitleFontFamily;
}, function (props) {
  return props.theme.groupTitleFontStyle;
}, function (props) {
  return props.theme.groupTitleFontWeight;
}, function (props) {
  return props.theme.groupTitleFontSize;
});

var SidenavGroupTitleButton = _styledComponents["default"].button(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  all: unset;\n  cursor: pointer;\n  justify-content: space-between;\n  box-sizing: border-box;\n  width: 100%;\n\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 19px;\n\n  display: flex;\n  align-items: center;\n  margin: 0px;\n  padding: 0.5rem 1.2rem;\n  &:focus-visible {\n    outline: 2px solid ", ";\n    outline-offset: -2px;\n  }\n  &:hover {\n    ", "\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n  }\n  ", "\n  svg {\n    width: 18px;\n    height: auto;\n  }\n"])), function (props) {
  return props.theme.groupTitleFontFamily;
}, function (props) {
  return props.theme.groupTitleFontStyle;
}, function (props) {
  return props.theme.groupTitleFontWeight;
}, function (props) {
  return props.theme.groupTitleFontSize;
}, function (props) {
  return props.theme.linkFocusColor;
}, function (props) {
  return props.selectedGroup ? "color: ".concat(props.theme.groupTitleSelectedHoverFontColor, "; background: ").concat(props.theme.groupTitleSelectedHoverBackgroundColor, ";") : "color: ".concat(props.theme.groupTitleFontColor, "; background: ").concat(props.theme.groupTitleHoverBackgroundColor, ";");
}, function (props) {
  return props.theme.groupTitleActiveBackgroundColor;
}, function (props) {
  return props.theme.groupTitleFontColor;
}, function (props) {
  return props.selectedGroup ? "color: ".concat(props.theme.groupTitleSelectedFontColor, "; background: ").concat(props.theme.groupTitleSelectedBackgroundColor, ";") : "color: ".concat(props.theme.groupTitleFontColor, "; background: transparent;");
});

var SidenavLink = _styledComponents["default"].a(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  letter-spacing: ", ";\n\n  text-transform: ", ";\n  text-decoration: ", ";\n\n  font-family: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 19px;\n\n  ", "\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  box-shadow: 0 0 0 2px transparent;\n\n  padding: 0.5rem 1.2rem;\n\n  cursor: pointer;\n  svg {\n    width: 16px;\n    margin-right: 0.5rem;\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: -2px;\n  }\n\n  &:active {\n    color: #ffffff;\n    background: #4d4d4d;\n    outline: 2px solid #0095ff;\n    outline-offset: -2px;\n  }\n"])), function (props) {
  return props.theme.linkFontLetterSpacing;
}, function (props) {
  return props.theme.linkFontTextTransform;
}, function (props) {
  return props.theme.linkTextDecoration;
}, function (props) {
  return props.theme.linkFontFamily;
}, function (props) {
  return props.theme.linkFontStyle;
}, function (props) {
  return props.theme.linkFontWeight;
}, function (props) {
  return props.theme.linkFontSize;
}, function (props) {
  return props.selected ? "color: ".concat(props.theme.linkSelectedFontColor, "; background: ").concat(props.theme.linkSelectedBackgroundColor, ";") : "color: ".concat(props.theme.linkFontColor, "; background: transparent;");
}, function (props) {
  return props.selected ? "color: ".concat(props.theme.linkSelectedHoverFontColor, "; background: ").concat(props.theme.linkSelectedHoverBackgroundColor, ";") : "color: ".concat(props.theme.linkFontColor, "; background: ").concat(props.theme.linkHoverBackgroundColor, ";");
}, function (props) {
  return props.theme.linkFocusColor;
});

var SidenavContent = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n\n  svg {\n    width: 16px;\n    margin-right: 0.5rem;\n  }\n"])));

var SidenavIcon = _styledComponents["default"].img(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 16px;\n  margin-right: 0.5rem;\n"])));

DxcSidenav.Section = Section;
DxcSidenav.Group = Group;
DxcSidenav.Link = Link;
DxcSidenav.Title = Title;
var _default = DxcSidenav;
exports["default"] = _default;